import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Ploop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Looping Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python loops tutorial for beginners.Looping Statement in Pythonis used to repeat a particular piece of cards until the given condition is false." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python loop,python loops,python loop for,python loop while,python loop range,for loop python 3,python loop through dictionary,python for loop break,python loop through list
,python loop dictionary,python for loop syntax,python loop list,python loop continue,python for loop continue,python loop example,python loop syntax,python loop counter,python loop over dictionary,python loop step,python loop with index,python loop break,python loop index,python loop string" />
<link rel="canonical" href="https://www.codeexampler.com/python-looping" />
</Helmet>

<div className='lg:pl-56'>

<h1 className="m-4 mh1">Looping Statement in Python</h1>

<div className="first">
        <a href="/python-if-else-if"> <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-while"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para"><span className="bold "> Python looping Statement:</span><br/>A looping Statement in Python uses to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are two types of loop statements in python programming:
</h2>
<h3 className="mt-4 mh3">1, Using a while loop in Python Statement<br/>
2, Using a for looping in Python

</h3>
<h2 className="mt-4 mh2">1, while loop in python:</h2>
<p className="mt-3 para">A while-loop for Python will give the Python condition, and the loop's body executes until the condition is false.
</p>
<h2 className="mt-4 mh2">while loop syntax in python</h2>
<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop python syntax</Card.Header>
  <Card.Body>
    <Card.Text>
    while (condition)<br/>
-<br/>
Statement<br/>
-<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer>That is a While loop syntax in python.</Card.Footer>
</Card>

    
<h2 className="mt-4 mh2">2, For loop python:</h2>
<p className="mt-4 para">1, Python While loop condition executes when the loop's body until that the condition is false.<br/>
2, 2, This for loop uses to repeat a particular piece of code for a fixed no of times<br/>
3, Python must use two semicolons<br/>
</p>
<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">for loop python syntax</Card.Header>
  <Card.Body>
    <Card.Text>
    For(Statement ;condition;Statement)<br/>
Statement;<br/>
    </Card.Text>
  </Card.Body>
</Card>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Ploop;